// extracted by mini-css-extract-plugin
export default {"wrapperIcon":"swiper_wrapperIcon__ZJ8FA","arrowIcon":"swiper_arrowIcon__-UOyI","contentWrapper":"swiper_contentWrapper__E7U9I"};